var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 10.0596C19.75 4.6419 15.3848 0.25 10 0.25C4.61522 0.25 0.25 4.6419 0.25 10.0596C0.25 14.9558 3.81541 19.0141 8.47656 19.75V12.8952H6.00098V10.0596H8.47656V7.89841C8.47656 5.43988 9.93221 4.08187 12.1593 4.08187C13.2257 4.08187 14.3418 4.27346 14.3418 4.27346V6.68754H13.1124C11.9013 6.68754 11.5234 7.44376 11.5234 8.22029V10.0596H14.2275L13.7953 12.8952H11.5234V19.75C16.1846 19.0141 19.75 14.9558 19.75 10.0596Z",
    fill: "#737373"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a2d01ad1.svg";
export { ForwardRef as ReactComponent };